import { george, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { IAccount } from "types/account";
import { Account } from "../common/Account";
import { LinkAccountStore } from "./LinkAccountStore";

type IProps = RouteComponentProps<{}> & {
    store: LinkAccountStore
};

@observer
export class LinkAccountSelect extends React.Component<IProps, {}> {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onLinkAccount = (account: IAccount) => {
        if (this.props.store.cardAccountsStore.isAccountLinked(account.id)) {
            this.props.store.cardAccountsStore.unlinkAccount(account.id);
        } else {
            this.props.store.cardAccountsStore.linkAccount(account.id);
        }
    }

    render() {
        const buttonLoading = this.props.store.isLoading || this.props.store.isLoadingLink;
        const buttonDisabled = this.props.store.cardAccountsStore.linkedAccountsChanged === false;
        const accounts = this.props.store.cardAccountsStore.linkableAccounts;

        const entries = accounts.map((account, index) =>
            <Account
                key={account.id}
                style={{ padding: theme.MARGIN }}
                account={account}
                checked={this.props.store.cardAccountsStore.isAccountLinked(account.id)}
                onSelectAccount={this.onLinkAccount}
                separator={index < accounts.length - 1}
                useCheckBoxes
            />
        );

        return (
            <george.Background>
                <george.PageWithActionButton>

                    {!this.props.store.isLoading &&
                        <div>
                            <george.Card>
                                <george.CardSectionTitle title={ui.__("linkAccount.document.title")} focus />
                                <george.CardSectionContent>
                                    <pr.P_14_CONTENT>{ui.__("linkAccount.info")}</pr.P_14_CONTENT>
                                </george.CardSectionContent>
                                <div>
                                    <pr.LightSeparatorLine />
                                    {entries}
                                </div>

                            </george.Card>
                        </div>
                    }

                    <george.LoadingIndicator isLoading={this.props.store.isLoading} height={ui.windowHeight} />

                    <george.ActionButton
                        messageId={buttonLoading ? undefined : "button.continue"}
                        disableButton={buttonDisabled}
                        isLoading={buttonLoading}
                        onClick={this.onSubmit}
                    />
                </george.PageWithActionButton>
            </george.Background>
        );
    }

    onSubmit = async () => {
        try {
            await this.props.store.linkAccounts();
            pushRoute("/link-account/signing");
        } catch (error) {
            pushRoute("/error");
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/linkAccount/LinkAccountSelect.tsx